import React from "react"
import { job } from "./styles.module.scss"

const Job = () => {
  return <div id="grnhse_app" className={job}></div>
}

export default Job
